import React from 'react';
import styled from 'styled-components';
import { Droppable } from 'react-beautiful-dnd';
import Task from './task';

const Container = styled.div`
  border: 1px solid lightgrey;
  border-radius: 2px;
  min-height: 100px;
  // width: 99%;
  height: auto;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 8px;
`;
const Title = styled.h3`
  padding: 8px;

  color: white;
`;
const TaskList = styled.div`
  padding: 8px;
  transition: background-color 0.2s ease;
  background-color: ${props => (props.isDraggingOver ? 'skyblue' : '282c34')};
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  height: auto;
  overflow: wrap;
  width: auto;
`;

export default class ColumnH extends React.Component {
  render() {
    return (
      <Container>
        <Title>{this.props.column.title}</Title>
        <Droppable style={{'display': 'flex', 'flex-wrap': 'wrap'}} droppableId={this.props.column.id} direction="horizontal">
          {(provided, snapshot) => (
            <TaskList
              ref={provided.innerRef}
              {...provided.droppableProps}
              isDraggingOver={snapshot.isDraggingOver}
            >
              {this.props.tasks.map((task, index) => (
                <Task key={task.id} task={task} index={index} />
              ))}
              {provided.placeholder}
            </TaskList>
          )}
        </Droppable>
      </Container>
    );
  }
}
